<div id="aboutMe" class="about-me-frame">
    <div class="a2-frame">
        <a id="a2" href="#contactFrame">
            Send a message
        </a>
    </div>

    <div class="sub-title">
        About me
    </div>
    
    <div class="text-pic-frame">
        <div class="left-frame">
            <div class="text-frame" id="textFrame">
                <div class="text" [innerHTML]="aboutMeText">
                    <!--is coming from text-data.json via language-service.ts -->
                </div>
            </div>                         
                <div class="btn-frame">
                    <a id="a1" href="#contactFrame">
                        Let's talk
                    </a>
                </div>            
        </div>
        <div class="right-frame">
            <div class="portrait">
                <img class="img-portrait" src="assets/images/portrait1.jpg" alt="portrait">
            </div>
            <div class="arrow-frame">
                <a id="a3" href="#mySkills">
                    <img class="arrow-left-down" src="assets/icons/arrow-left-pic.png" alt="arrow-left">
                </a>
            </div>
        </div>
    </div>

    <div class="text-overlay" *ngIf="showTextOverlay">
        <div class="overlay-content">            
            <button class="close-overlay" (click)="toggleTextOverlay()"><img src="assets/icons/x-mark-48.png" alt="close"></button>
            <div class="text" [innerHTML]="aboutMeText">
             <!--is coming from text-data.json via language-service.ts -->
            </div>            
        </div>
    </div>

</div>